// extracted by mini-css-extract-plugin
export default {"SurfacePanneau":"SurfacePanneau_SurfacePanneau__PERhj","TitreEtBouton":"SurfacePanneau_TitreEtBouton__euZ3B"};